import { AxiosResponse } from 'axios';
import { apiB2B } from '../axios-client';
import { B2B_MANAGE_USERS_PATH } from '../../constants/links';
import { withUserContext } from '../utils';

export const sortByMap = {
  Name: 'firstName',
  Email: 'email',
  Phone: 'phone',
  Role: 'role',
  Status: 'status',
  'Date Added': 'addedDate',
} as const;
export type TSortByLabel = keyof typeof sortByMap;
export type TSortByValue = (typeof sortByMap)[TSortByLabel];

export interface ISortConfig {
  page?: number;
  sortBy?: TSortByValue;
  ascendingOrder?: boolean;
}

export const SEARCH_BY = {
  name: 'Name',
  status: 'Status',
  role: 'Role',
} as const;

export type TUserSearchType = keyof typeof SEARCH_BY | 'default';

export interface IFilterConfig {
  type: TUserSearchType;
  value: string;
}

export const MANAGE_USERS_PAGE_SIZE = 21;

export const defaultFilterConfig: IFilterConfig = {
  type: 'default',
  value: 'default',
};

export interface IUsersResponse {
  paginationInfo: IPaginationInfo;
  users: IUserData[];
}

export interface IPaginationInfo {
  pageNumber: string;
  pageSize: string;
  totalNumberOfRecords: string;
  totalPages: string;
}

export interface IUserData {
  accountOwner: 'Y' | 'N';
  activatedDate?: string;
  addedById: string;
  addedDate: string;
  customerAccountId: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  phoneType?: string;
  role: TUserRoles;
  status: TInviteStatus;
  userId: string;
  isInviteExpired?: boolean;
}

export type TUserRoles = 'Runner' | 'Purchaser' | 'Admin';
export type TInviteStatus = 'Pending' | 'Active';

export const usersApi = {
  getUsers: withUserContext(
    (
      userId,
      svocId,
      sortConfig?: ISortConfig,
      filterConfig?: IFilterConfig,
    ): Promise<AxiosResponse<IUsersResponse>> =>
      apiB2B.post(
        B2B_MANAGE_USERS_PATH(userId, svocId),
        {
          UserSearch: filterConfig || defaultFilterConfig,
        },
        {
          params: {
            ps: MANAGE_USERS_PAGE_SIZE,
            pn: sortConfig?.page || 1,
            sb: sortConfig?.sortBy || 'addedDate',
            asc: sortConfig?.ascendingOrder || false,
          },
        },
      ),
  ),
};
